export default __webpack_public_path__ + "d67be8abc7017374c7e81cf9246ee6fd.png";